import React from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'gatsby';
import { WelcomeSellBox, BreadCrumbBlock, SideCategoryMenu, RepeatingPostItem } from '../../../components';

export const CategoryLayout = ({ data, pathContext, location }) => {
    const subCategoryExists = data.mb.subcategories?.length > 0;
    const MAX_BLOGPOST_LIST_PER_CATEGORY = 6;
    return (
    <div className="categories">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, minimum-scale=1" />
        <title>FreeConferenceCall Support Center</title>
      </Helmet>
      <WelcomeSellBox />
      <BreadCrumbBlock location={location} label={pathContext.name} subcategories={pathContext.subcategories} categories={pathContext.categories} />
      <div className="block-sm">
        <div className="container">
          <div className="row">

            {/* Side Categories menu */}
            <div className="col-sm-3">
              <SideCategoryMenu categories={data?.mb?.menu_categories} />
            </div>

            {/* Right side main content */}
            <div className="col-sm-9 main-section">
              <h2 className="section-title">{pathContext.name}</h2>
              
              {/* subcategories lists */}
              {subCategoryExists ? 
                <div className="sub-categories-sections">
                  {data?.mb?.subcategories?.map((subcategory, index) => (
                    <div key={index} className="section-column">
                      <h4>{subcategory.name}</h4>
                      <ul>
                        {subcategory.blogposts?.slice(0, MAX_BLOGPOST_LIST_PER_CATEGORY).map(post => (
                          <li key={post.id}>
                            <Link className="category-link" to={`/${post.slug}`} title={post.title}>
                              {post.title}
                            </Link>
                          </li>
                        ))}

                        {
                          (subcategory.blogposts?.length > MAX_BLOGPOST_LIST_PER_CATEGORY) && 
                          <Link className="category-link margin-top-sm" to={`/${pathContext.link}/${subcategory.link}`} title={subcategory.name}>
                            See all articles...
                          </Link>
                        }
                      </ul>
                    </div>
                  ))}
                </div>
                : null
              }

              {/* If no subcategories, then try to show list of posts */}
              {(!subCategoryExists && data?.mb?.posts.length > 0) ? (
                <div className="category-list">
                {data.mb.posts.map(post => (
                  <RepeatingPostItem key={post.id} post={post} />
                ))}
                </div>
            )
            : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

